export const conversionCase = [
  'booking\/complete'
];

export const categoryCases = [
  'holidays$', 'offers$', 'hotels$', 'flights$', 'destinations$'
];

export const idBasedPageV2 = ['^(\\d+-\\d+(?:-\\d+)?)$'];
export const idBasedPageV3 = ['^(\\d+-\\d+-\\d+-\\d+)$'];

export const holidayDeals = [
  '(offers\/early-summer-holidays)$',
  '(offers\/winter-sun)$',
];

export const listingCases = [
  // 'holidays'
  'holidays\/flights\/(?:(.{8}-.{4}-.{4}-.{4}-.{12}))$',
  'holidays\/hotels\/(?:(.{8}-.{4}-.{4}-.{4}-.{12}))$',
  '(\\d+-\\d+-\\d+-\\d+)\/([a-zA-Z-_]+)(?:(\\?[a-zA-Z-_]+)?)$', // same for hotels & holidays
  // 'hotels'
  'hotels\/(?:(.{8}-.{4}-.{4}-.{4}-.{12}))$',
  // flights
  'flights\/(?:(.{8}-.{4}-.{4}-.{4}-.{12}))$'
];

export const offerCases = [
  // holidays
  '(\\d+-\\d+(?:-\\d+)?\/)([a-zA-Z-_]+)(?:(\\?[a-zA-Z-_]+)?)$',
  'holidays\/(.{8}-.{4}-.{4}-((?:.{4}-)?)(.{12}|.{16}))\/(\\d+)\?(.+)$',
  // hotels
  'hotels\/(.{8}-.{4}-.{4}-((?:.{4}-)?)(.{12}|.{16}))\/(\\d+)\?(.+)$',
  // flights
  'holidays\/options\/(.{8}-.{4}-.{4}-((?:.{4}-)?)(.{12}|.{16}))$'
];

export const cartCases = [
  // holidays
  'holidays\/options\/(.{8}-.{4}-.{4}-((?:.{4}-)?)(.{12}|.{16}))\?(.+)$',
  // hotels
  'hotels\/book\/(.{8}-.{4}-.{4}-((?:.{4}-)?)(.{12}|.{16}))\?(.+)$',
  // flights
  'holidays\/book\/(.{8}-.{4}-.{4}-((?:.{4}-)?)(.{12}|.{16}))$',
];

export const bookingCases = [
  'holidays\/book\/(.{8}-.{4}-.{4}-((?:.{4}-)?)(.{12}|.{16}))\?(.+)$'
];
